import React from 'react';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import { ArrowBack, InfoOutlined, MoreVert } from '@mui/icons-material';
import colors from '../../assets/theme/colors';

const CareTeamChatHeader = ({
  title,
  subtitle,
  onBack,
  onInfoClick,
  onMenuClick,
}) => (
  <Box
    sx={{
      px: 2,
      pt: 1.75,
      pb: 1.5,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      borderBottom: '1px solid',
      borderColor: 'rgba(226, 232, 240, 0.75)',
      backgroundColor: '#FFFFFF',
    }}
  >
    <IconButton onClick={onBack} aria-label="Back to conversations" sx={{ color: colors.landing.heroText }}>
      <ArrowBack />
    </IconButton>

    <Avatar
      sx={{
        width: 46,
        height: 46,
        bgcolor: '#AEE1D4',
        color: colors.landing.heroText,
        fontSize: '1.3rem',
        flexShrink: 0,
      }}
    >
      👥
    </Avatar>

    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: '1.3rem',
          fontWeight: 800,
          lineHeight: 1.15,
          color: colors.landing.heroText,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {title}
      </Typography>
      <Typography sx={{ mt: 0.35, fontSize: '0.92rem', color: colors.landing.textMuted }}>
        {subtitle}
      </Typography>
    </Box>

    <IconButton
      onClick={onInfoClick}
      aria-label="Open care circle details"
      sx={{ color: '#1C9A8B' }}
    >
      <InfoOutlined />
    </IconButton>
    <IconButton onClick={onMenuClick} aria-label="Conversation actions" sx={{ color: colors.landing.heroText }}>
      <MoreVert />
    </IconButton>
  </Box>
);

export default CareTeamChatHeader;
